// extracted by mini-css-extract-plugin
export default {"env":"Layout_env__DQGaH"};